var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C19.404 0 25 5.596 25 12.5S19.404 25 12.5 25 0 19.404 0 12.5 5.596 0 12.5 0zm0 1C6.149 1 1 6.149 1 12.5S6.149 24 12.5 24 24 18.851 24 12.5 18.851 1 12.5 1zM8.417 11c.779 0 1.416.637 1.416 1.417a1.42 1.42 0 01-1.416 1.416A1.42 1.42 0 017 12.417C7 11.637 7.638 11 8.417 11zm8.5 0c.779 0 1.416.637 1.416 1.417a1.42 1.42 0 01-1.416 1.416 1.42 1.42 0 01-1.417-1.416c0-.78.637-1.417 1.417-1.417zm-4.25 0c.779 0 1.416.637 1.416 1.417a1.42 1.42 0 01-1.416 1.416 1.42 1.42 0 01-1.417-1.416c0-.78.637-1.417 1.417-1.417z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreCircle);
export default __webpack_public_path__ + "static/media/MoreCircle.c1fc2812.svg";
export { ForwardRef as ReactComponent };